import {Shape} from "./model/shapes/types";

export type CanvasElementType = "image" | "shape" | "group" | "text";

export type CanvasElement = {
  id: string;
  name: string;
  type: CanvasElementType;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  opacity: number;
  visible: boolean;
  locked: boolean;
}

export type ImageCanvasElement = CanvasElement & {
  type: "image";
  src: string;
  htmlImage: HTMLImageElement;
}

export type ShapeCanvasElement = CanvasElement & {
  type: "shape";
  shape: Shape;
  fill: string;
}

export type GroupCanvasElement = CanvasElement & {
  type: "group";
  children: CanvasElement[];
}

export type TextCanvasElement = CanvasElement & {
  type: "text";
  text: string;
  fontSize: number;
  fontFamily: string;
  fill: string;
  align: "left" | "center" | "right";
  fontStyle: string; // "normal", "bold", "italic", "bold italic"
}

export function isGroupElement(el: CanvasElement): el is GroupCanvasElement {
  return el.type === "group";
}

export function isTextElement(el: CanvasElement): el is TextCanvasElement {
  return el.type === "text";
}

export type UploadedPhoto = {
  id: string;
  src: string;
  htmlImage: HTMLImageElement;
  name: string;
}
